import React from 'react';

interface DeleteMeasureDialogProps {
  isOpen: boolean;
  measureIndex: number;
  onClose: () => void;
  onDelete: (measureIndex: number) => void;
}

const DeleteMeasureDialog: React.FC<DeleteMeasureDialogProps> = ({
  isOpen,
  measureIndex,
  onClose,
  onDelete,
}) => {
  const handleDelete = () => {
    onDelete(measureIndex);
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleDelete();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-96 max-w-sm mx-4 shadow-xl">
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          Delete Measure
        </h3>
        
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
          Are you sure you want to delete <strong>Measure {measureIndex + 1}</strong>?
          <br />
          <br />
          <span className="text-red-600 dark:text-red-400 font-medium">
            This action cannot be undone.
          </span>
        </p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            onKeyDown={handleKeyDown}
            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white
                     border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700
                     transition-colors duration-200"
            autoFocus
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            onKeyDown={handleKeyDown}
            className="px-4 py-2 bg-red-500 hover:bg-red-600 
                     text-white rounded-md transition-colors duration-200"
          >
            Delete Measure
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMeasureDialog;